import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "45",
  height: "45",
  viewBox: "0 0 45 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.19984 29.3C5.89984 24.9 7.49983 20.6 10.4998 17.3C13.4998 14.1 17.7998 12.3 22.1998 12.3C26.5998 12.3 30.8998 14.1 33.8998 17.3C36.8998 20.5 38.4998 24.9 38.1998 29.3C36.7998 29.3 35.4998 29.3 34.0998 29.3C34.1998 28.7 34.1998 28 34.0998 27.4C34.7998 27.4 35.4998 27.4 36.1998 27.4C35.9998 24.4 34.7998 21.6 32.8998 19.3C32.3998 19.8 31.8998 20.3 31.3998 20.8C30.9998 20.3 30.4998 19.8 29.9998 19.3C30.4998 18.8 30.9998 18.3 31.4998 17.8C29.1998 15.8 26.3998 14.6 23.3998 14.4C23.3998 15.1 23.3998 15.8 23.3998 16.5C22.6998 16.4 21.9998 16.4 21.2998 16.5C21.2998 15.8 21.2998 15.1 21.2998 14.4C18.2998 14.6 15.4998 15.8 13.1998 17.7C13.6998 18.2 14.1998 18.7 14.6998 19.2C14.1998 19.6 13.6998 20.1 13.1998 20.6C12.6998 20.1 12.1998 19.6 11.6998 19.1C9.69984 21.4 8.49981 24.2 8.29981 27.2C8.99981 27.2 9.69982 27.2 10.3998 27.2C10.2998 27.9 10.2998 28.6 10.3998 29.3C8.89982 29.3 7.59984 29.3 6.19984 29.3Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24.7002 28.6C26.3002 26.1 27.8001 23.6 29.4001 21.2C26.9001 22.8 24.4001 24.3 22.0001 25.9C21.0001 26 20.2001 26.7 19.9001 27.6C19.6001 28.5 19.8001 29.5 20.5001 30.2C21.2001 30.9 22.2001 31.1 23.1001 30.8C23.9001 30.4 24.6002 29.6 24.7002 28.6Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }